import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../../utils/api';
import { Brand } from '../ui/Brand';
import { AcceptanceForm, AttendanceHelp } from './LegalDocuments';
import './legal.css';

export default function LegalGate({ user, onLogout, children }) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const refresh = useCallback(() => { setStatus(null); setError(''); setAttempt(a => a + 1); }, []);
  useEffect(() => {
    let live = true;
    apiFetch('/api/legal/status').then(data => {
      if (!live) return;
      if (data.ok) setStatus(data);
      else setError(data.message || 'We could not load your review status. Please try again.');
    });
    return () => { live = false; };
  }, [user.id, attempt]);
  useEffect(() => {
    window.addEventListener('scheduler-legal-required', refresh);
    return () => window.removeEventListener('scheduler-legal-required', refresh);
  }, [refresh]);
  async function accept(documents) {
    if (saving) return;
    setSaving(true); setError('');
    const result = await apiFetch('/api/legal/accept', { method: 'POST', body: JSON.stringify({ documents }) });
    if (result.ok && result.accepted) setStatus(result);
    else if (result.code === 'LEGAL_VERSION_MISMATCH') { refresh(); setError('The documents changed. Please review the current versions.'); }
    else setError(result.message || 'Your review was not saved. Please try again.');
    setSaving(false);
  }
  if (status?.accepted) return children;
  return <main className="legal-shell"><div className="legal-card"><Brand subtitle="Your workplace account" />
    <h1>Review Scheduler’s terms and privacy notice</h1>
    <p>Signed in as <strong>{user.name}</strong>. Read how Scheduler is used and how your information is handled before continuing.</p>
    {error && <div role="alert" className="legal-error">{error} {!status && <button className="btn btn-secondary btn-sm" onClick={refresh}>Try again</button>}</div>}
    {!status && !error && <p role="status">Loading your review status…</p>}
    {status && <AcceptanceForm documents={status.documents} onAccept={accept} saving={saving} />}
    <AttendanceHelp />
    <div className="legal-actions"><a href="/legal" target="_blank" rel="noreferrer">Legal &amp; Privacy</a><button className="btn btn-ghost" onClick={onLogout} disabled={saving}>Sign out</button></div>
  </div></main>;
}
